import iFrameResize from 'iframe-resizer/js/iframeResizer.min';

(() => {
  const { url, form, type } = document.currentScript.dataset;
  const embedId = `connect-embed-${form}`;

  // A dynamic form question has position absolute which is a challenge for the iframeResize plugin
  // Thus we opted to not have the iframeResize plugin to do its magic for dynamic forms.
  // Static forms are okidoki
  const allowResize = type !== 'dynamic';

  const frame = document.createElement('iframe');
  frame.src = url;
  frame.id = embedId;
  frame.style.border = 0;
  frame.style.width = '100%';
  document.currentScript.parentNode.insertBefore(frame, null);

  function handleIframeMessage({ message = {} }) {
    switch (message.event) {
      case 'form:redirect-to':
        window.location.href = message.payload.url;
        break;
      case 'form:reset':
        // TODO scroll TO
        break;
      case 'form:loaded':
        if (!allowResize) {
          frame.style.height = '100vh';
        }
        break;
      default:
      // TODO do nothing
    }
  }

  iFrameResize({
    log: false,
    autoResize: allowResize,
    checkOrigin: [RMP_CONNECT_EMBED.IFRAME_WHITELIST_DOMAINS], // eslint-disable-line
    onMessage: handleIframeMessage,
  }, `#${embedId}`);
})();

// child.on('form:loaded')
// child.on('form:change-height')
// child.on('form:reset-scroll')
// child.on('form:redirect-to')
